<template>
  <div>
    <div class="banner flex">
      <div class="banner-content">
        <div class="banner-title">数据集贡献榜单</div>
        <!--div class="update-time">更新时间：{{ formatter(fullData[0]) }}</div-->
        <p class="banner-text">
          安全数据集共建、合作、评测需求请联系：
          <el-link
            style="color: #005aff !important"
            type="primary"
            href="mailto: secbench@tencent.com"
            target="_blank"
          >
            secbench@tencent.com
          </el-link>
        </p>
      </div>
    </div>
    <div class="container-box">
      <el-table
        :data="tableData"
        style="width: 100%"
        :cell-style="{ padding: '10px 5px' }"
        :header-cell-style="{
          padding: '10px 5px',
          color: 'rgb(136, 136, 136)',
          'font-weight': 400,
          background: '#f9f9fb',
          'border-bottom': '1px solid rgb(231, 234, 239)',
        }"
        :default-sort="{ prop: 'date', order: 'descending' }"
        stripe
      >
        <el-table-column label="排名" align="center">
          <template slot-scope="scope">
            <div v-if="scope.$index < 3" :class="`rank rank-${scope.$index + 1}`"></div>
            <span v-else>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="model" label="贡献者">
          <template slot-scope="scope">
            <div class="flex contributor-div">
              <el-avatar :src="scope.row.avatar"></el-avatar>
              <div class="contributor">{{ scope.row.user }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="分数" sortable></el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
// import index from '@/config/index';
import { doHttp } from '@/common/simple_http';

export default {
  data() {
    return {
      fullData: [],
      tableData: [],
      currentPage: 0,
      pageSize: 10,
      total: 0,
    };
  },
  created: function () {
    this.getContributor();
  },
  mounted() {},
  methods: {
    handleSizeChange() {},
    handleCurrentChange() {},
    getContributor() {
      doHttp('/data/getContributor', 'post', {}, (rst) => {
        this.fullData = rst.data.sort((n1, n2) => {
          return n2.score - n1.score;
        });
        this.total = rst.data.length;
        this.tableData = this.fullData.slice(
          this.currentPage * this.pageSize,
          (this.currentPage + 1) * this.pageSize
        );
      });
    },
    modelDetail(modelName) {
      this.$router.push({
        path: `/detail?modelName=${modelName}`,
      });
    },
  },
};
</script>

<style lang="less" scoped>
// 使用通用的 less 变量和 mixin 方法
@import '~@/assets/styles/_var.less';
@import '~@/assets/styles/_mixin.less';

.banner {
  margin-top: 48px;
  background-color: #e4eef6;
  // background: linear-gradient(278.56deg, #eef7ff 23.59%, rgba(238, 247, 255, 0) 70.87%);
  background: url(https://secbench-1258476245.cos.ap-guangzhou.myqcloud.com/secbench/board_banner.png),
    linear-gradient(102deg, #dee8f1 0%, #dde7f0 100%);
  background-position: center;
  background-size: auto 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 397px;
  .justify-content(center);
  .banner-content {
    width: @width;
    padding-top: 37px;
    .banner-title {
      font-size: 40px;
      line-height: 60px;
      margin-top: 20px;
      font-family: TencentSans;
      font-weight: 700;
    }
    .banner-btn {
      margin-top: 10px;
    }
    .logos {
      margin-top: 40px;
      background-image: url('../../assets/images/logos.png');
      background-size: contain;
      width: 394px;
      height: 30px;
    }
  }
}
.container-box {
  width: @width;
  margin-top: -123px;
  padding: 20px 20px 0 20px;
  .el-table {
    font-size: 12px;
  }
}
.update-time {
  padding-top: 22px;
  line-height: 21px;
  color: rgba(82, 92, 114, 0.5);
}
.banner-text {
  font-size: 14px;
  line-height: 20px;
  color: rgba(82, 92, 114, 1);
  font-family: Source Han Sans CN;
  width: 680px;
  margin-top: 30px;
}
.pagination {
  background: #fff;
  padding: 15px 30px;
  text-align: right;
}
.el-tag {
  background-color: rgb(219, 232, 255);
  border: none;
  color: @color-primary;
  border-radius: 0;
  height: 20px;
  line-height: 20px;
  &.el-tag--success {
    background: #defae4;
    color: @color-success;
  }
}
.organization {
  color: #888888;
}
.contributor-div {
  .align-items();
  .contributor {
    line-height: 40px;
    margin-left: 10px;
  }
}
/deep/.rank {
  width: 30px;
  height: 30px;
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  &.rank-1 {
    background-image: url(~@/assets/images/1.png);
  }
  &.rank-2 {
    background-image: url(~@/assets/images/2.png);
  }
  &.rank-3 {
    background-image: url(~@/assets/images/3.png);
  }
}
</style>
